import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
/**
 * Homepage poll spotlight: the newest active poll rendered as a full-width
 * results card with a 2-column option grid. Renders nothing when there's no
 * poll (e.g. fof/polls disabled).
 */
export default class HomePoll extends Component {
  view() {
    var _poll$options, _poll$voteCount, _poll$subtitle;
    const poll = this.attrs.poll;
    if (!poll || typeof poll.question !== 'function') return null;
    const options = (((_poll$options = poll.options) == null ? void 0 : _poll$options.call(poll)) || []).slice();
    const total = ((_poll$voteCount = poll.voteCount) == null ? void 0 : _poll$voteCount.call(poll)) || options.reduce((s, o) => {
      var _o$voteCount;
      return s + (((_o$voteCount = o.voteCount) == null ? void 0 : _o$voteCount.call(o)) || 0);
    }, 0) || 0;

    // fof/polls registers its public list page under the route name
    // `fof.polls.showcase` (path `/polls`) — NOT `polls`. Calling app.route()
    // with an unregistered name THROWS and aborts the whole render, so resolve
    // it defensively and fall back to the bare path.
    const pollsHref = app.routes['fof.polls.showcase'] ? app.route('fof.polls.showcase') : '/polls';
    return m("section", {
      className: "HomeSection"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "HomePoll"
    }, m("div", {
      className: "HomePoll-head"
    }, m("div", null, m("span", {
      className: "HomePoll-tag"
    }, app.translator.trans('glowingblue-demo.forum.home.poll.tag')), m("div", {
      className: "HomePoll-q"
    }, poll.question()), ((_poll$subtitle = poll.subtitle) == null ? void 0 : _poll$subtitle.call(poll)) && m("p", {
      className: "HomePoll-help"
    }, poll.subtitle())), m("div", {
      className: "HomePoll-meta"
    }, app.translator.trans('glowingblue-demo.forum.home.poll.votes', {
      count: total
    }))), m("div", {
      className: "HomePoll-grid"
    }, options.map(opt => {
      var _opt$voteCount, _opt$answer, _opt$label;
      const votes = ((_opt$voteCount = opt.voteCount) == null ? void 0 : _opt$voteCount.call(opt)) || 0;
      const pct = total ? Math.round(votes / total * 100) : 0;
      return m("div", {
        className: "HomePoll-opt"
      }, m("span", {
        className: "HomePoll-fill",
        style: {
          width: pct + '%'
        }
      }), m("span", {
        className: "HomePoll-lbl"
      }, ((_opt$answer = opt.answer) == null ? void 0 : _opt$answer.call(opt)) || ((_opt$label = opt.label) == null ? void 0 : _opt$label.call(opt))), m("span", {
        className: "HomePoll-pct"
      }, pct, "%"));
    })), m("div", {
      className: "HomePoll-foot"
    }, m("span", {
      className: "HomePoll-metamono"
    }, app.translator.trans('glowingblue-demo.forum.home.poll.cast')), m(Link, {
      href: pollsHref,
      className: "Button Button--primary"
    }, m("span", {
      className: "Button-label"
    }, app.translator.trans('glowingblue-demo.forum.home.poll.vote')))))));
  }
}
flarum.reg.add('glowingblue-demo', 'forum/components/home/HomePoll', HomePoll);